import { create } from "zustand"
import botStore from "./botStore"
import { API_URL } from "../services/constants"

// Helper function to construct banner URL
const getBannerUrl = (bannerId) => {
    const templateName = botStore.getState().bot.templateName
    return `${API_URL}/static/${templateName}:${bannerId}`
}

// Helper to enrich banner with URL
const enrichBanner = (banner) => ({
    ...banner,
    url: getBannerUrl(banner.id),
})

const bannersStore = create((set) => ({
    banners: null,
    selectedBanner: null,

    setBanners: (banners) => set({ banners }),

    setSelectedBanner: (banner) =>
        set({
            selectedBanner: banner ? enrichBanner(banner) : null,
        }),

    addBanner: (newBanner) =>
        set((state) => ({
            banners: [...(state.banners || []), enrichBanner(newBanner)],
        })),

    updateBanner: (banner) => {
        const enrichedBanner = enrichBanner(banner)
        return set((state) => ({
            selectedBanner: enrichedBanner,
            banners: (state.banners || []).map((b) => (b.id === banner.id ? enrichedBanner : b)),
        }))
    },

    deleteBanner: (bannerId) =>
        set((state) => ({
            banners: (state.banners || []).filter((b) => b.id !== bannerId),
            selectedBanner: state.selectedBanner?.id === bannerId ? null : state.selectedBanner,
        })),
}))

// You can optionally export methods like this (though getState() is fine too)
export const useBannerStore = bannersStore

export const bannerStoreMethods = {
    addBanner: (data) => bannersStore.getState().addBanner(data),
    updateBanner: (data) => bannersStore.getState().updateBanner(data),
    deleteBanner: (bannerId) => bannersStore.getState().deleteBanner(bannerId),
    setBanners: (banners) => bannersStore.getState().setBanners(banners),
    setSelectedBanner: (banner) => bannersStore.getState().setSelectedBanner(banner),
}

export default bannersStore
